import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A standard React Router Link. Scrolling to top on navigation is handled
 * globally by the ScrollToTop component.
 */
const ScrollToTopLink = ({ to, children, ...props }) => (
  <Link to={to} {...props}>{children}</Link>
);

export default ScrollToTopLink;
